export default {
  name: 'TableCell',
  props: {
    title: {
      type: [String, Number],
      default: ''
    },

    content: {
      type: [String, Number],
      default: ''
    },

    size: {
      type: Number,
      default: 14
    },
    icon: {
      type: String,
      default: ''
    },
    titleFocus: {
      type: Boolean,
      default: false
    },

    contentSize: {
      type: Number,
      default: 14
    },

    align: {
      type: String,
      default: 'right'
    }
  },
  computed: {
    style() {
      return { fontSize: this.size + 'px' }
    },
    titleClass() {
      return this.titleFocus ? ['focus'] : []
    },
    contentStyle() {
      return {
        fontSize: this.contentSize + 'px'
      }
    },
    classes() {
      let cls = []
      if (this.align) {
        cls.push('align-' + this.align)
      }
      return cls
    }
  },
  render() {
    return <div class="sl-table-cell" style={this.style} class={this.classes}>
        <div>
          <span class={this.titleClass}>
            { this.icon ? <i class={this.icon}></i> : null }
            {this.title}
          </span>
          <p style={this.contentStyle}>{this.content}</p>
        </div>
    </div>
  }
}
